import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import styled from 'styled-components';
import 'react-table/react-table.css';
import { epochToDate } from 'utils';
import PropTypes from 'prop-types';

const TableWrapper = styled.div`
  margin: 5px;
`;

class StudentAddOns extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      addOns: [],
    };
  }

  static defaultProps = {
    addOns: [],
    studentCourses: [],
  };

  static propTypes = {
    addOns: PropTypes.arrayOf(PropTypes.shape({})),
    studentCourses: PropTypes.arrayOf(PropTypes.shape({})),
  };

  static getDerivedStateFromProps(props, state) {
    let { studentCourses, addOns } = props;
    const newState = {};
    let courseIdObj = {};

    studentCourses.forEach(({ id, course_name: courseName }) => {
      courseIdObj[id] = courseName;
    });

    addOns.forEach(data => {
      const { student_course_id: studentCourseId } = data;
      if (courseIdObj[studentCourseId]) {
        data['course_name'] = courseIdObj[studentCourseId];
      } else {
        data['course_name'] = '';
      }
    });
    newState.addOns = addOns;
    return newState;
  }

  render() {
    const { addOns } = this.state;
    let columnsData = [
      {
        Header: 'Add-on Name',
        accessor: 'addon_name',
      },
      {
        Header: 'Add-on Type',
        accessor: 'addon_type',
      },
      {
        Header: 'Course Tagged',
        accessor: 'course_name',
      },
      {
        Header: 'Purchased Date',
        accessor: 'purchased_date',
        Cell: ({ value }) => (value ? epochToDate(value, 'DD-MM-YYYY') : ''),
      },
      {
        Header: 'Duration (in months)',
        accessor: 'duration',
      },
      {
        Header: 'Comments',
        accessor: 'comments',
        Cell: ({ value }) => (value ? value : '-'),
      },
    ];

    const tableColumns = [
      {
        Header: ``,
        columns: columnsData,
      },
    ];

    return (
      <TableWrapper>
        <ReactTable
          data={addOns}
          columns={tableColumns}
          defaultPageSize={addOns.length !== 0 ? addOns.length : 4}
          style={{ maxHeight: 300, textAlign: 'center' }}
          className="-striped -highlight"
        />
      </TableWrapper>
    );
  }
}
export default StudentAddOns;
